import React from 'react';
import { ConnectButton as RainbowConnectButton } from '@rainbow-me/rainbowkit';

interface ConnectButtonProps {
    className?: string;
}

const ConnectButton: React.FC<ConnectButtonProps> = ({ className }) => {
    return (
        <RainbowConnectButton.Custom>
            {({
                account,
                chain,
                openAccountModal,
                openChainModal,
                openConnectModal,
                mounted,
            }) => {
                const ready = mounted;
                const connected = ready && account && chain;

                return (
                    <div
                        {...(!ready && {
                            'aria-hidden': true,
                            style: {
                                opacity: 0,
                                pointerEvents: 'none',
                                userSelect: 'none',
                            },
                        })}
                        className={className}
                    >
                        {(() => {
                            if (!connected) {
                                return (
                                    <button
                                        onClick={openConnectModal}
                                        className="connect-btn"
                                        type="button"
                                    >
                                        <span className="connect-btn-text">Connect Wallet</span>
                                        <span className="connect-btn-glow"></span>
                                    </button>
                                );
                            }

                            if (chain.unsupported) {
                                return (
                                    <button
                                        onClick={openChainModal}
                                        className="connect-btn connect-btn-wrong"
                                        type="button"
                                    >
                                        Wrong Network
                                    </button>
                                );
                            }

                            return (
                                <div className="connected-wrapper">
                                    <button
                                        onClick={openChainModal}
                                        className="chain-btn"
                                        type="button"
                                    >
                                        {chain.hasIcon && (
                                            <div className="chain-icon">
                                                {chain.iconUrl && (
                                                    <img
                                                        alt={chain.name ?? 'Chain icon'}
                                                        src={chain.iconUrl}
                                                        className="chain-icon-img"
                                                    />
                                                )}
                                            </div>
                                        )}
                                        <span>{chain.name}</span>
                                    </button>

                                    <button
                                        onClick={openAccountModal}
                                        className="account-btn"
                                        type="button"
                                    >
                                        <span className="account-address">
                                            {account.displayName}
                                        </span>
                                        {account.displayBalance && (
                                            <span className="account-balance">
                                                {account.displayBalance}
                                            </span>
                                        )}
                                    </button>
                                </div>
                            );
                        })()}
                    </div>
                );
            }}
        </RainbowConnectButton.Custom>
    );
};

export default ConnectButton;
